import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Card from "react-bootstrap/Card";
import Alert from "react-bootstrap/Alert";
import { useEffect, useState } from "react";

const api = require("../Assets/api.json");

function Converter(props) {
  const [formData, setFormData] = useState({
    inputMbtile: null,
    format: "",
    flipRow: true,
    projection: 3857,
  });

  const [authKey, setAuthKey] = useState("Bearer ");

  const [alert, setAlert] = useState({
    title: "",
    message: "",
  });

  const [isProcessing, setIsProcessing] = useState(false);
  const [isForm, setIsForm] = useState(false);
  const [isAlert, setIsAlert] = useState(false);

  const resetForm = () => {
    setFormData({
      inputMbtile: null,
      format: "",
      flipRow: true,
      projection: 3857,
    });
  };

  const downloadURI = (dataurl, filename) => {
    const link = document.createElement("a");
    link.href = dataurl;
    link.download = filename;
    link.click();
  };

  const startConversion = async () => {
    setIsProcessing(true);
    setIsAlert(false);
    setIsForm(false);
    try {
      if (formData.inputMbtile) {
        if (formData.format && formData.format.length > 3) {
          if (
            formData.projection &&
            formData.projection.toString().length > 3
          ) {
            ///
            let formdata = new FormData();
            formdata.append("File", formData.inputMbtile);
            formdata.append("OutputFormat", formData.format);
            formData.format === "vtpk"
              ? formdata.append("Format", "Vector")
              : formdata.append("Format", "Raster");
            formdata.append("Projection", formData.projection);
            formdata.append("ReverseRow", formData.flipRow);

            const response = await fetch(api.endpoints.convert, {
              headers: {
                Authorization: authKey,
              },
              method: "POST",
              body: formdata,
            });

            if (response.status == 200) {
              const resp = await response.json();

              if (
                (resp.conversionStatus === "Conversion Successful",
                resp.fileURL.length > 10 && resp.fileName.length > 4)
              ) {
                downloadURI(resp.fileURL, resp.fileName);
                setIsForm(true);
                setIsProcessing(false);
                setIsAlert(false);
                resetForm();
              } else {
                setAlert({
                  title: "Conversion Failed",
                  message: "Error occured while conversion, try later",
                });
                setIsForm(false);
                setIsProcessing(false);
                setIsAlert(true);
              }
            } else {
              setAlert({
                title: "Conversion Failed",
                message: "Your session expired, login again and then convert",
              });
              setIsForm(false);
              setIsProcessing(false);
              setIsAlert(true);
            }

            ///
          } else {
            setAlert({
              title: "Select Projection",
              message:
                "You did not selected the output file projection, kindly select valid option from list and then convert",
            });
            setIsForm(false);
            setIsProcessing(false);
            setIsAlert(true);
          }
        } else {
          setAlert({
            title: "Select Format",
            message:
              "You did not selected the output file format, kindly select either TPKX or VTPK and then convert",
          });
          setIsForm(false);
          setIsProcessing(false);
          setIsAlert(true);
        }
      } else {
        setAlert({
          title: "Select Input File",
          message:
            "You did not selected the input file, kindly select mbtiles and then convert",
        });
        setIsForm(false);
        setIsProcessing(false);
        setIsAlert(true);
      }
    } catch (error) {
      console.log(error);
      setIsProcessing(false);
      setIsAlert(false);
      setIsForm(true);
    }
  };

  useEffect(() => {
    let token = localStorage.getItem("esri-tile-converter-token");
    if (token) {
      setAuthKey(`Bearer ${token}`);
    } else {
      setAlert({
        title: "Not Login",
        message: "Your session is expired, Kindly login again",
      });
      setIsForm(false);
      setIsProcessing(false);
      setIsAlert(true);
    }
    setIsForm(true);
    setIsProcessing(false);
    setIsAlert(false);
  }, []);

  return (
    <div>
      {/* <h2>Convert Mbtiles (Raster/Vector) into (TPKX/VTPK)</h2> */}
      {isForm && (
        <Card style={{ margin: 20 }}>
          <Card.Header>Convert Mbtiles into TPKX / VTPK</Card.Header>
          <Card.Body>
            <Card.Title></Card.Title>
            <Form>
              <Container>
                <Row>
                  <Col>
                    <Form.Label>Input Mbtiles</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      type="file"
                      size="sm"
                      accept=".mbtiles, |MBTILES/*"
                      onChange={(e) =>
                        setFormData((existing) => ({
                          ...existing,
                          inputMbtile: e.target.files[0],
                        }))
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Label>Format</Form.Label>
                  </Col>
                  <Col>
                    <Form.Select
                      aria-label="Select Output Format"
                      value={formData.format}
                      onChange={(e) =>
                        setFormData((existing) => ({
                          ...existing,
                          format: e.target.value,
                        }))
                      }
                    >
                      <option>Select</option>
                      <option value="tpkx">TPKX - Raster</option>
                      <option value="vtpk">VTPK - Vector</option>
                    </Form.Select>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Label>Flip Row</Form.Label>
                  </Col>
                  <Col>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      defaultChecked={formData.flipRow}
                      onClick={(e) =>
                        setFormData((existing) => ({
                          ...existing,
                          flipRow: e.target.checked,
                        }))
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Label>Projection</Form.Label>
                  </Col>
                  <Col>
                    <Form.Select
                      aria-label="Select Output Format"
                      value={formData.projection}
                      onChange={(e) =>
                        setFormData((existing) => ({
                          ...existing,
                          projection: e.target.value,
                        }))
                      }
                    >
                      <option>Select</option>
                      <option value="3857">EPSG - 3857</option>
                      <option value="3395">EPSG - 3395</option>
                      <option value="4326">EPSG - 4326</option>
                    </Form.Select>
                  </Col>
                </Row>

                <Row>
                  <Col></Col>
                  <Col>
                    <Button variant="success" onClick={() => startConversion()}>
                      Convert
                    </Button>
                  </Col>
                  <Col></Col>
                </Row>
              </Container>
            </Form>
          </Card.Body>
        </Card>
      )}

      {isProcessing && (
        <Card style={{ margin: 20 }}>
          <Card.Header>Processing</Card.Header>
          <Card.Body>
            <Spinner animation="grow" variant="success" />
          </Card.Body>
        </Card>
      )}

      {isAlert && (
        <Alert show={isAlert} variant="info">
          <Alert.Heading>{alert.title}</Alert.Heading>
          <p>{alert.message}</p>
          <hr />
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => {
                setIsAlert(false);
                setIsForm(true);
                setIsProcessing(false);
                setAlert({
                  title: "",
                  message: "",
                });
              }}
              variant="outline-info"
            >
              Ok
            </Button>
          </div>
        </Alert>
      )}
    </div>
  );
}
export default Converter;
